import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [links, setLinks] = useState({});
  const [site, setSite] = useState({});
  const [sections, setSections] = useState([]);
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/links/map").then((r) => setLinks(r.data)).catch(() => {}),
      api.get("/settings/site").then((r) => setSite(r.data.data || {})).catch(() => {}),
      api.get("/sections").then((r) => setSections(r.data)).catch(() => {}),
      api.get("/settings/menu").then((r) => setMenu((r.data.data && r.data.data.items) || [])).catch(() => {}),
    ]);
  }, []);

  const linkFor = (key) => links[key] || "#";
  const trackAndGo = (key) => {
    const url = linkFor(key);
    if (url && url !== "#") {
      api.post(`/links/click/${key}`).catch(() => {});
      window.open(url, "_blank", "noopener");
    }
  };

  return (
    <SiteContext.Provider value={{ links, site, sections, menu, linkFor, trackAndGo }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
